import { render, staticRenderFns } from "./orderPhoto.vue?vue&type=template&id=269cd2c8&scoped=true&"
import script from "./orderPhoto.vue?vue&type=script&lang=js&"
export * from "./orderPhoto.vue?vue&type=script&lang=js&"
import style0 from "./orderPhoto.vue?vue&type=style&index=0&id=269cd2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269cd2c8",
  null
  
)

export default component.exports